export const getFullName = (user: { firstName: string; lastName: string } | null) => {
	return user != null ? `${user.firstName} ${user.lastName}` : '';
};
export const getInitials = (user: { firstName: string; lastName: string } | null) => {
	return user != null ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}` : '';
};
